import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
export var useScrollDeviceDetect = function useScrollDeviceDetect() {
  var isActive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var _useState = useState('mouse'),
    _useState2 = _slicedToArray(_useState, 2),
    device = _useState2[0],
    setDevice = _useState2[1];

  // https://stackoverflow.com/questions/10744645/detect-touchpad-vs-mouse-in-javascript логика функции взята отсюда (есть полное объяснение в ишью)
  var handler = function handler(event) {
    // В тс нет записи об этом поле в WheelEvent API
    var e = event;
    var isTrackpad = e.wheelDeltaY ? Math.abs(e.wheelDeltaY) !== 120 : e.deltaMode === 0;
    setDevice(isTrackpad ? 'touchpad' : 'mouse');
  };
  useEffect(function () {
    if (isActive) {
      document.addEventListener('mousewheel', handler, false);
      document.addEventListener('DOMMouseScroll', handler, false);
    }
    return function () {
      document.removeEventListener('mousewheel', handler, false);
      document.removeEventListener('DOMMouseScroll', handler, false);
    };
  }, [isActive]);
  return device;
};